import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCornerRadius: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="corner-radius, border-radius" maskId="round-filled-radius-0-stroke-1.5-IconCornerRadius"><path d="M3 20.25V3.75L3.00391 3.67285C3.04253 3.29488 3.36183 3 3.75 3H20.25L20.3271 3.00391C20.7051 3.04253 21 3.36183 21 3.75C21 4.13817 20.7051 4.45747 20.3271 4.49609L20.25 4.5H4.5V20.25C4.5 20.6642 4.16421 21 3.75 21C3.33579 21 3 20.6642 3 20.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCornerRadius;
